import Card from "@mui/material/Card"
import facility_types from "../../configs/facility_types.json"
import theme_colors from "../../configs/theme_colors.json"

export default function FacilityLegend({ visible_facilities }) {
  const { cups } = theme_colors

  return (
    <Card
      style={{
        position: "absolute",
        bottom: "30px",
        right: "4px",
        zIndex: 600,
        padding: 5,
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
        }}
      >
        <tbody>
          <tr>
            <td style={{ color: cups }}>■</td>
            <td>CUPs Point</td>
          </tr>

          {facility_types
            .filter(({ type }) => visible_facilities.includes(type))
            .map(({ name, colour, symbol }, i) => (
              <tr key={i}>
                <td style={{ color: colour }}>{symbol}</td>
                <td>{name}</td>
              </tr>
            ))}
        </tbody>
      </table>
    </Card>
  )
}
